// Thin sonner wrapper used across the app for in-app notifications.
//
// Use these helpers instead of window.alert(). For confirmation
// dialogs use confirmDialog() from components/ui/confirm-dialog.
import { toast } from 'sonner';

const baseOpts = { duration: 3500 };
const errorOpts = { duration: 5000 };

export const notify = {
  success: (msg, opts = {}) => toast.success(String(msg), { ...baseOpts, ...opts }),
  error:   (msg, opts = {}) => toast.error(String(msg),   { ...errorOpts, ...opts }),
  info:    (msg, opts = {}) => toast(String(msg),         { ...baseOpts, ...opts }),
  warning: (msg, opts = {}) => toast.warning(String(msg), { ...baseOpts, ...opts }),
  message: (msg, opts = {}) => toast(String(msg),         { ...baseOpts, ...opts }),
  dismiss: () => toast.dismiss(),
};

// Heuristic for routing legacy alert() calls to the right toast variant.
const ERROR_PATTERNS = /(?:^|\W)(failed|failure|error|unable|cannot|can't|invalid|insufficient|please (?:upload|enter|allow)|too large|not supported|must be (?:less than|at least|under)|max(?:imum)? \d|denied|forbidden|expired|no longer available)/i;
const SUCCESS_PATTERNS = /(?:^|\W)(success(?:fully)?|redeemed|connected|disconnected|copied|saved|created|joined|updated)/i;

export const alertToToast = (message) => {
  const text = String(message ?? '');
  if (!text) return;
  if (ERROR_PATTERNS.test(text)) return notify.error(text);
  if (SUCCESS_PATTERNS.test(text)) return notify.success(text);
  return notify.message(text);
};

// Install a global override so any stray `alert()` call (in legacy code
// paths we haven't migrated yet) renders as an in-app toast instead of a
// native browser dialog. Idempotent.
export const installAlertOverride = () => {
  if (typeof window === 'undefined') return;
  if (window.__alertOverrideInstalled) return;
  window.__alertOverrideInstalled = true;
  // Keep a reference in case anything needs to bypass (e.g. truly fatal
  // boot errors) — not currently used.
  window.__nativeAlert = window.alert.bind(window);
  window.alert = (msg) => alertToToast(msg);
};

export default notify;
